import React from 'react';
import { wrapDisplayName } from 'recompose';
import { connect } from 'react-redux';
import { createCancelToken } from '@deerplusofficial/pos-helper';
import { withClient } from '@deerplusofficial/pos-hoc';
import _ from 'lodash';
import fp from 'lodash/fp';
import actions from '../../actions';

const {
  detail: { reset: resetDetail },
} = actions.preOrder;

export default config => Component =>
  fp.compose(
    withClient(),
    connect(
      null,
      { resetDetail }
    )
  )(
    class extends React.Component {
      static displayName = wrapDisplayName(Component, 'WithCancelPreOrder');

      componentWillUnmount() {
        !_.isUndefined(this.stopCancelPreOrder) && this.stopCancelPreOrder();
      }

      onDelete = async id => {
        const {
          resetDetail,
          client: { POSApi, onError },
        } = this.props;

        try {
          await POSApi.delete(`/pre_orders/${id}`, {
            cancelToken: createCancelToken(this.stopCancelPreOrder),
          });
          resetDetail();
        } catch (error) {
          onError(error);
        }
      };

      render() {
        return <Component {...this.props} onPreOrderCancel={this.onDelete} />;
      }
    }
  );



// WEBPACK FOOTER //
// ./src/model/Mutations/withCancelPreOrder.js